
export class Attachment {
    id: number;
    created_at: any;
    name: string;
    file: any;
    message_id: number;

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.created_at = apiModel.created_at;
        this.name = apiModel.name;
        this.file = apiModel.file;
        this.message_id = apiModel.message_id;
        return this;
    }
}
